import { fetchGETRequest, fetchPOSTRequest } from "./services";

const API_V2_ADJUSTMENTS = "v2/Adjustments";

export interface AdjustmentV2 {
  id: string;
  adjustmentNumber: string;
  customerId: string;
  customerName: string;
  contractId: string;
  contractNumber: string;
  billId: string;
  billNumber: string;
  adjustmentType: string;
  amount: number;
  reason: string;
  status: string;
  requestedBy: string;
  approvedBy: string | null;
  approvedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AdjustmentListV2Response {
  success: boolean;
  data: AdjustmentV2[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export interface AdjustmentDetailsV2Response {
  success: boolean;
  message: string | null;
  data: AdjustmentV2;
  errors?: any;
}

export interface CreateAdjustmentV2Request {
  customerId: string;
  contractId: string;
  billId: string;
  adjustmentType: string;
  amount: number;
  reason: string;
  requestedBy: string;
}

export interface ApproveAdjustmentV2Request {
  approvedBy: string;
}

export interface RejectAdjustmentV2Request {
  rejectedBy: string;
  rejectionReason: string;
}

export const getAdjustmentsV2 = async (params: {
  customerId?: string;
  contractId?: string;
  status?: string;
  adjustmentType?: string;
  page?: number;
  pageSize?: number;
}) => {
  let query = "";
  const queryParts = [];
  if (params.customerId) queryParts.push(`CustomerId=${params.customerId}`);
  if (params.contractId) queryParts.push(`ContractId=${params.contractId}`);
  if (params.status) queryParts.push(`Status=${params.status}`);
  if (params.adjustmentType)
    queryParts.push(`AdjustmentType=${params.adjustmentType}`);
  if (params.page !== undefined) queryParts.push(`Page=${params.page + 1}`);
  if (params.pageSize !== undefined)
    queryParts.push(`PageSize=${params.pageSize}`);

  if (queryParts.length > 0) {
    query = `?${queryParts.join("&")}`;
  }

  return await fetchGETRequest<AdjustmentListV2Response>(
    `${API_V2_ADJUSTMENTS}${query}`,
  );
};

export const getAdjustmentDetailsV2 = async (id: string) => {
  return await fetchGETRequest<AdjustmentDetailsV2Response>(
    `${API_V2_ADJUSTMENTS}/${id}`,
  );
};

export const createAdjustmentV2 = async (body: CreateAdjustmentV2Request) => {
  const pascalBody = {
    CustomerId: body.customerId,
    ContractId: body.contractId,
    BillId: body.billId,
    AdjustmentType: body.adjustmentType,
    Amount: body.amount,
    Reason: body.reason,
    RequestedBy: body.requestedBy,
  };
  return await fetchPOSTRequest<AdjustmentDetailsV2Response>(
    API_V2_ADJUSTMENTS,
    pascalBody,
  );
};

export const approveAdjustmentV2 = async (
  id: string,
  body: ApproveAdjustmentV2Request,
) => {
  const pascalBody = {
    ApprovedBy: body.approvedBy,
  };
  return await fetchPOSTRequest<{ success: boolean }>(
    `${API_V2_ADJUSTMENTS}/${id}/approve`,
    pascalBody,
  );
};

export const rejectAdjustmentV2 = async (
  id: string,
  body: RejectAdjustmentV2Request,
) => {
  const pascalBody = {
    RejectedBy: body.rejectedBy,
    RejectionReason: body.rejectionReason,
  };
  return await fetchPOSTRequest<{ success: boolean }>(
    `${API_V2_ADJUSTMENTS}/${id}/reject`,
    pascalBody,
  );
};
